var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGenericError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 212 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M5.21537 183.817H4.12109V189.962H5.21537V183.817Z",
    fill: "#47E6B1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.77344 186.35V187.433H1.56574V186.35H7.77344Z",
    fill: "#47E6B1"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M115.379 0H114.332V6.14501H115.379V0Z",
    fill: "#47E6B1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.826 2.5293V3.61252L111.888 3.61252V2.5293L117.826 2.5293Z",
    fill: "#47E6B1"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M64.158 18.3096H63.1113V24.4546H64.158V18.3096Z",
    fill: "#47E6B1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.6055 20.8389V21.9221H60.6677V20.8389H66.6055Z",
    fill: "#47E6B1"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.925 193.339C193.47 193.143 193.236 192.64 193.38 192.17C193.391 192.135 193.399 192.099 193.401 192.063C193.414 191.849 193.285 191.653 193.082 191.579C192.879 191.505 192.652 191.571 192.522 191.742C192.499 191.771 192.481 191.803 192.466 191.836C192.268 192.287 191.76 192.519 191.286 192.375C191.25 192.364 191.214 192.357 191.177 192.355C190.962 192.342 190.763 192.47 190.688 192.671C190.614 192.871 190.681 193.097 190.853 193.225C190.883 193.247 190.915 193.266 190.948 193.28C191.404 193.476 191.638 193.979 191.493 194.449C191.482 194.484 191.475 194.52 191.472 194.556C191.459 194.769 191.589 194.966 191.792 195.04C191.994 195.114 192.222 195.048 192.352 194.877C192.374 194.848 192.392 194.816 192.407 194.783C192.605 194.332 193.113 194.1 193.588 194.243C193.623 194.254 193.659 194.261 193.696 194.264C193.912 194.277 194.11 194.149 194.185 193.948C194.26 193.747 194.193 193.522 194.02 193.393C193.991 193.372 193.959 193.353 193.925 193.339Z",
    fill: "#4D8AF0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5695 141.931C34.1144 141.734 33.8801 141.232 34.0247 140.762C34.036 140.727 34.0431 140.691 34.0459 140.655C34.0589 140.441 33.9291 140.245 33.7264 140.171C33.5238 140.097 33.2961 140.163 33.1661 140.334C33.144 140.363 33.1255 140.394 33.1109 140.428C32.9128 140.879 32.4049 141.11 31.9301 140.967C31.895 140.956 31.8587 140.949 31.822 140.946C31.6064 140.933 31.4077 141.062 31.333 141.263C31.2583 141.463 31.3252 141.688 31.4976 141.817C31.5271 141.839 31.5591 141.857 31.593 141.872C32.0481 142.068 32.2825 142.571 32.1378 143.041C32.1266 143.075 32.1194 143.111 32.1166 143.148C32.1036 143.361 32.2334 143.558 32.4361 143.632C32.6387 143.706 32.8664 143.64 32.9965 143.469C33.0185 143.44 33.037 143.408 33.0516 143.374C33.2497 142.924 33.7576 142.692 34.2324 142.835C34.2675 142.846 34.3038 142.853 34.3406 142.856C34.5562 142.869 34.7548 142.74 34.8295 142.54C34.9042 142.339 34.8374 142.114 34.6649 141.985C34.6354 141.963 34.6034 141.945 34.5695 141.931Z",
    fill: "#FDD835"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.314 16.579C167.859 16.3829 167.624 15.8801 167.769 15.4101C167.78 15.3753 167.787 15.3394 167.79 15.303C167.803 15.0896 167.673 14.893 167.471 14.819C167.268 14.7451 167.04 14.8113 166.91 14.9819C166.888 15.0112 166.87 15.0429 166.855 15.0764C166.657 15.5269 166.149 15.7589 165.674 15.6157C165.639 15.6046 165.603 15.5975 165.566 15.5947C165.351 15.5819 165.152 15.7104 165.077 15.911C165.002 16.1116 165.069 16.3369 165.242 16.4657C165.271 16.4875 165.303 16.5058 165.337 16.5202C165.792 16.7164 166.027 17.2191 165.882 17.6892C165.871 17.7239 165.864 17.7598 165.861 17.7962C165.848 18.0096 165.978 18.2063 166.18 18.2802C166.383 18.3542 166.611 18.288 166.741 18.1173C166.763 18.0881 166.781 18.0564 166.796 18.0229C166.994 17.5723 167.502 17.3404 167.977 17.4835C168.012 17.4947 168.048 17.5017 168.085 17.5045C168.3 17.5174 168.499 17.3889 168.574 17.1883C168.648 16.9877 168.582 16.7623 168.409 16.6336C168.38 16.6117 168.348 16.5934 168.314 16.579Z",
    fill: "#FDD835"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M205.241 79.5778C206.224 79.5778 207.02 78.7895 207.02 77.8172C207.02 76.8449 206.224 76.0566 205.241 76.0566C204.259 76.0566 203.463 76.8449 203.463 77.8172C203.463 78.7895 204.259 79.5778 205.241 79.5778Z",
    fill: "#F55F44"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M58.6906 188.732C59.6729 188.732 60.4692 187.944 60.4692 186.972C60.4692 185.999 59.6729 185.211 58.6906 185.211C57.7084 185.211 56.9121 185.999 56.9121 186.972C56.9121 187.944 57.7084 188.732 58.6906 188.732Z",
    fill: "#F55F44"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M185.321 121.127C186.304 121.127 187.1 120.338 187.1 119.366C187.1 118.394 186.304 117.605 185.321 117.605C184.339 117.605 183.543 118.394 183.543 119.366C183.543 120.338 184.339 121.127 185.321 121.127Z",
    fill: "#F55F44"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M21.6984 25.3522C22.6807 25.3522 23.477 24.5639 23.477 23.5916C23.477 22.6193 22.6807 21.8311 21.6984 21.8311C20.7162 21.8311 19.9199 22.6193 19.9199 23.5916C19.9199 24.5639 20.7162 25.3522 21.6984 25.3522Z",
    fill: "#4D8AF0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1.77852 77.4645C2.76077 77.4645 3.55705 76.6763 3.55705 75.7039C3.55705 74.7316 2.76077 73.9434 1.77852 73.9434C0.796272 73.9434 0 74.7316 0 75.7039C0 76.6763 0.796272 77.4645 1.77852 77.4645Z",
    fill: "#47E6B1"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.596 56.4303C136.758 35.9344 161.806 46.7187 167.246 63.9802C166.155 72.6108 160.715 79.0799 152.001 81.2416C160.715 82.3224 167.246 75.8455 168.337 68.2956C180.316 62.8994 196.652 68.2956 196.652 84.4761C205.365 83.3952 212.987 92.0259 211.896 100.657C210.805 110.368 199.917 116.837 191.204 112.522C184.673 127.622 165.064 130.864 154.176 118.991C150.91 120.072 148.728 120.072 146.553 117.91C145.462 126.541 137.84 133.01 130.218 131.937C129.127 144.883 116.057 155.667 102.996 152.433C97.5477 150.279 93.191 148.117 91.0167 143.802C86.66 156.748 69.2341 157.829 62.7016 145.956C51.8141 152.425 34.3866 147.037 31.1213 134.091C28.947 124.379 32.2125 113.595 39.8346 109.28C38.7434 108.2 38.7434 106.046 37.6603 104.965C25.6814 111.434 9.34519 106.046 6.07997 93.0996C1.72325 79.0727 10.4367 62.8928 30.0373 65.0531C35.4851 55.3415 46.3727 55.3415 53.9946 59.6569C51.8203 43.4764 62.7078 27.2959 83.4001 30.5302C99.7355 3.56584 137.853 32.6839 119.336 56.4226C120.427 55.3418 121.51 55.3418 122.602 56.4226L122.596 56.4303Z",
    fill: "#2D91E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.8319 183.803H73.4121L71.1406 177.465H74.552L76.8319 183.803Z",
    fill: "#1663A7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.39 200H76.6574L75.4102 193.662H79.1427L80.39 200Z",
    fill: "#1663A7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.5639 167.606H70.0693L67.584 161.268H71.3165L72.5639 167.606Z",
    fill: "#1663A7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.1947 183.803H89.4529L88.2148 177.465H91.9474L93.1947 183.803Z",
    fill: "#1663A7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.269 183.803H106.529L105.289 177.465H109.029L110.269 183.803Z",
    fill: "#1663A7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.054 183.803H124.322L123.074 177.465H126.816L128.054 183.803Z",
    fill: "#1663A7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.129 183.803H141.717L139.438 177.465H142.857L145.129 183.803Z",
    fill: "#1663A7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.4628 200H94.043L91.7715 193.662H95.1828L97.4628 200Z",
    fill: "#1663A7"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.826 200H110.084L108.846 193.662H112.578L113.826 200Z",
    fill: "#1663A7"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.9 200H127.16L125.92 193.662H129.659L130.9 200Z",
    fill: "#1663A7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.396 200H145.663L144.416 193.662H148.158L149.396 200Z",
    fill: "#1663A7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.349 167.606H86.6095L85.3691 161.268H89.1086L90.349 167.606Z",
    fill: "#1663A7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.423 167.606H103.691L102.443 161.268H106.185L107.423 167.606Z",
    fill: "#1663A7"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.498 167.606H121.087L118.807 161.268H122.226L124.498 167.606Z",
    fill: "#1663A7"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.572 167.606H137.839L136.592 161.268H140.324L141.572 167.606Z",
    fill: "#1663A7"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.859 99.155C122.859 98.1702 122.575 97.1826 122.006 96.2665L107.636 74.2236C106.641 72.6748 104.932 71.7588 103.154 71.7588C101.303 71.7588 99.6688 72.6748 98.6712 74.2236L84.3014 96.3377C83.2343 97.9579 83.162 100.071 84.0874 101.76C85.0128 103.449 86.8608 104.505 88.7839 104.505H117.454C119.447 104.505 121.225 103.449 122.151 101.76C122.645 100.915 122.859 100.071 122.859 99.1546L122.859 99.155ZM120.013 100.563C119.516 101.479 118.518 102.043 117.451 102.043L88.8531 102.041C87.786 102.041 86.7912 101.477 86.2909 100.561C85.7935 99.6446 85.7935 98.5196 86.3632 97.6035L100.664 75.4922C101.234 74.6477 102.087 74.1553 103.082 74.1553C104.076 74.1553 105.002 74.6477 105.499 75.4922L119.8 97.6035C120.083 98.0959 120.228 98.5883 120.228 99.1522C120.37 99.6474 120.3 100.14 120.014 100.563L120.013 100.563Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.658 94.6465H104.646V97.744H101.658V94.6465Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.658 82.1143H104.646V92.0452H101.658V82.1143Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.303 56.126H104.932V59.7187H101.303V56.126Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.303 120.562H104.932V124.155H101.303V120.562Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.4707 110.211H81.1V113.804H77.4707V110.211Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.141 110.211H127.77V113.804H124.141V110.211Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.4707 65.9854H81.1V69.578H77.4707V65.9854Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.141 65.9854H127.77V69.578H124.141V65.9854Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.3672 88.0283H71.9965V91.621H68.3672V88.0283Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.314 88.0283H137.944V91.621H134.314V88.0283Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.981 72.0424C72.2771 76.1275 70.5708 80.6333 69.9288 85.4945L69.8594 85.9154H71.9936L72.0659 85.5633C72.7773 80.8455 74.5558 76.3365 77.2597 72.395L77.6877 71.8311H75.1977L74.981 72.0424Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.9252 94.0855L71.853 93.7334H69.791L69.8633 94.157C70.5024 99.1582 72.1392 103.736 74.8431 107.961L74.9849 108.102H77.4748L77.0468 107.538C74.3429 103.521 72.5644 98.8721 71.9253 94.0855H71.9252Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.241 85.6346L134.313 85.9867H136.447L136.375 85.5631C135.664 80.7051 133.958 76.1962 131.323 72.111L131.181 71.9707H128.691L129.119 72.5346C131.751 76.4079 133.53 80.9135 134.241 85.6346H134.241Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.383 93.7334L134.31 94.0855C133.671 98.8748 131.893 103.593 129.189 107.538L128.764 108.17H131.254L131.395 108.03C134.099 103.876 135.805 99.2272 136.375 94.2258L136.447 93.8022L134.383 93.7334Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.3 64.0848L120.372 64.1563H123.929L123.004 63.4521C118.521 60.0712 113.114 57.8871 107.494 57.1828L107.066 57.1113V59.224L107.422 59.2955C112.046 59.931 116.387 61.4798 120.3 64.0848L120.3 64.0848Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.1617 63.4521L82.2363 64.1563H85.7934L85.8656 64.0848C89.8507 61.4797 94.1884 59.931 98.8851 59.2955L99.2408 59.224V57.1113L98.8129 57.1828C93.1216 57.8871 87.7163 60.0713 83.1619 63.4521L83.1617 63.4521Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.656 116.057C116.671 118.662 112.119 120.423 107.354 121.058L106.998 121.13V123.242L107.426 123.171C113.19 122.395 118.667 120.214 123.291 116.693L124.217 115.988L120.656 116.057Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.5835 116.057L85.4418 115.985H81.957L82.8824 116.69C87.5066 120.211 93.0563 122.395 98.8166 123.168L99.2445 123.239V121.127L98.886 120.986C94.1202 120.351 89.4962 118.59 85.5834 116.057L85.5835 116.057Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenericError);
export default __webpack_public_path__ + "static/media/GenericError.40cf8bc709bdf946b67cada3805241bf.svg";
export { ForwardRef as ReactComponent };